import { render, staticRenderFns } from "./VideoCategoryPopup.vue?vue&type=template&id=a717f056&"
import script from "./VideoCategoryPopup.vue?vue&type=script&lang=js&"
export * from "./VideoCategoryPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports